import { useEffect } from 'react';

import { DialogContentText } from '@mui/material';
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { AppDialog } from 'components/Dialogs';
import strings from 'constants/index';

export const AliasCollisionDialog = ({ isOpen, onHide, message, onClick }) => {
  useEffect(() => {
    const reqInterceptor = axios.interceptors.request.use(
      async (config: InternalAxiosRequestConfig) => {
        const resultConfig = config;
        if (config.method === 'put') {
          resultConfig.data = { ...resultConfig.data, skipDuplicateAliasValidation: true };
        }

        return resultConfig;
      },
      (error: AxiosError) => Promise.reject(error),
    );

    return () => axios.interceptors.request.eject(reqInterceptor);
  }, []);

  return (
    <AppDialog
      open={isOpen}
      title={strings.warning}
      onClose={onHide}
      confirmButton={{
        label: strings.yes,
        props: { onClick },
      }}
    >
      <DialogContentText>{message}</DialogContentText>
    </AppDialog>
  );
};
